import { render, staticRenderFns } from "./DialogErrorUncollect.vue?vue&type=template&id=7f7f90e8&"
import script from "./DialogErrorUncollect.vue?vue&type=script&lang=js&"
export * from "./DialogErrorUncollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports